/* Site-Specific JavaScript */
document.addEventListener('DOMContentLoaded', function () {

    // Sticky header: hide on scroll down, show on scroll up (desktop only)
    (function initHeaderScrollHide() {
        const header = document.getElementById('site-header');
        if (!header) {
            return;
        }

        const desktopMq = window.matchMedia('(min-width: 992px)');
        const hiddenClass = 'header-hidden';
        const delta = 8;
        let lastScrollY = window.scrollY;
        let ticking = false;

        function setHeaderHidden(shouldHide) {
            document.body.classList.toggle(hiddenClass, shouldHide);
        }

        function onScroll() {
            ticking = false;

            if (!desktopMq.matches) {
                setHeaderHidden(false);
                lastScrollY = window.scrollY;
                return;
            }

            const currentY = Math.max(0, window.scrollY);
            const headerHeight = header.offsetHeight;

            if (currentY <= headerHeight) {
                setHeaderHidden(false);
            } else if (currentY > lastScrollY + delta) {
                setHeaderHidden(true);
            } else if (currentY < lastScrollY - delta) {
                setHeaderHidden(false);
            }

            lastScrollY = currentY;
        }

        function requestScrollUpdate() {
            if (!ticking) {
                ticking = true;
                window.requestAnimationFrame(onScroll);
            }
        }

        window.addEventListener('scroll', requestScrollUpdate, { passive: true });

        desktopMq.addEventListener('change', function () {
            if (!desktopMq.matches) {
                setHeaderHidden(false);
            }
        });

        header.addEventListener('focusin', function () {
            setHeaderHidden(false);
        });
    })();


    // Fetch stockdio data for zero-nav-ticker
    const stockdioConfigEl = document.querySelector('.stockdio-config');
    const stockdioConfig = stockdioConfigEl ? JSON.parse(stockdioConfigEl.textContent) : null;
    if (stockdioConfig) {
        const decodeConfigValue = (value) => {
            try {
                return decodeURIComponent(String(value));
            } catch (error) {
                return String(value);
            }
        };
        const stockdioAppKey = decodeConfigValue(stockdioConfig.appKey);
        const stockdioSymbol = decodeConfigValue(stockdioConfig.symbol);
        const stockdioExchange = decodeConfigValue(stockdioConfig.exchange);
        const stockdioCurrencySymbol = stockdioConfig.currencySymbol;
        const stockdioCompanyName = stockdioConfig.companyName;
        const stockdioApiUrl = 'https://api.stockdio.com/data/financial/prices/v1/GetStocksSnapshot';

        const params = new URLSearchParams({
            'app-key': stockdioAppKey,
            'stockExchange': stockdioExchange,
            'symbols': stockdioSymbol,
        });

        fetch(`${stockdioApiUrl}?${params}`)
            .then(response => response.json())
            .then(json => {
                const tickers = document.querySelectorAll('.stockdio-ticker');
                const columns = json?.data?.columns;
                const row = json?.data?.values?.[0];
                if (!tickers.length || !columns || !row) return;

                const col = (name) => row[columns.indexOf(name)];

                const company = stockdioCompanyName || col('company');
                const price = parseFloat(col('close'));
                const change = parseFloat(col('change'));
                const exchangeKey = String(stockdioExchange).replace(/:$/, '').toUpperCase();
                let currency = stockdioCurrencySymbol || col('currencySymbol') || '';
                if (exchangeKey === 'ASX' && currency !== 'A$') {
                    currency = 'A$';
                } else if (currency === 'USD') {
                    currency = '$';
                }
                const decimals = parseInt(col('Decimals'), 10) || 2;
                const formatAmount = (amount) => amount.toLocaleString('en-US', {
                    minimumFractionDigits: decimals,
                    maximumFractionDigits: decimals,
                });
                const isNegative = change < 0;
                const sign = isNegative ? '-' : (change > 0 ? '+' : '');
                const direction = isNegative ? 'negative' : 'positive';
                const absChange = Math.abs(change);

                tickers.forEach(ticker => {
                    const companyEl = ticker.querySelector('.company-name');
                    if (companyEl && company) {
                        companyEl.textContent = company;
                    }
                    ticker.querySelector('.price .value').textContent =
                        currency + formatAmount(price);
                    ticker.querySelector('.change .value').textContent =
                        sign + formatAmount(absChange);
                    ticker.classList.add(direction);
                });
            })
            .catch(error => {
                console.error('Stockdio API request failed:', error);
            });
    }
});


/*
 * Footnotes Functionality
 */

document.addEventListener("DOMContentLoaded", function () {
    // replace {{}} with <sup></sup>

    // Regex for superscript symbols
    const superscriptSymbolRegex = /[*†‡§¶]/g;
    // Regex for superscript numbers and letters wrapped in () or []
    const superscriptRegexStart = /^(?:\(|\[)([a-zA-Z0-9])(?:\)|\])\s+/;
    const superscriptRegexEnd = /(?:\(|\[)\s*([a-zA-Z0-9]+)\s*(?:\)|\])$/;
    // Bare number/letter when the element itself is a <sup> (e.g. <sup>1</sup>)
    const superscriptRegexBare = /^[a-zA-Z0-9]+$/;
    const superscriptSelector = ".stat p, .stat p sup, .stat sup, .stat-box p, .chart-header h3, .tab-content .stat .description, h2 sup, h3 sup, td sup, th sup, .segment-map-legend li sup, .segment-investment-map p sup, .module-content p, .module-content p sup, .module-content h2, .module-content h2 sup, .module-content h3, .module-content h3 sup, .module-stats h2, .module-stats h2 sup, .stat__field-value sup, .stat--value, .stat--value sup, .project-parameters__label, .project-parameters__label sup, .project-parameters__description, .project-parameters__description p, .project-parameters__description sup, .project-parameters__card-value, .project-parameters__card-value sup, .project-parameters__card-caption, .project-parameters__card-caption p, .project-parameters__card-caption sup, .row-project-parameters .text h2, .row-project-parameters .text h2 sup";
    const footnoteSelector = ".financial-disclaimer .financial-text p, .source p, .row-source p, .source li, .source ol > li, .row-footnotes-accordion .footnotes .text ol > li, .row-footnotes-accordion .footnotes .text li, .row-footnotes-accordion .footnotes .text p, .footnotes .text ol > li, .row-project-parameters .text ol > li";

    superScriptFixerUpper();
    setTimeout(function () {
        superScriptFixerUpper();
    }, 1000);

    document.addEventListener('click', function (event) {
        const link = event.target.closest('a.footnote-link, a.footnote-backlink, a.span-asterisk');
        if (!link || !link.hash) {
            return;
        }

        const target = document.querySelector(link.hash);
        if (!target) {
            return;
        }

        event.preventDefault();
        revealFootnoteSource(target, function () {
            smoothScrollToHash(link.hash);
            if (typeof target.focus === 'function') {
                target.focus({ preventScroll: true });
            }
        });
    });

    if (document.querySelector('.chart-wrapper')) {
        // Required for chartjs that resets on resize.
        jq(window).resize(function (evt) {
            setTimeout(() => {
                superScriptFixerUpper();
            }, 100);
        });
    
        // Also run when clicking on a tab that has a footnote in a chart
        // Why 1100? I don't know, 1000 is not enough but 1100 is.
        var tabs = document.querySelectorAll('.nav-tabs .nav-links');
        tabs.forEach(function (tab) {
            tab.addEventListener('click', function (e) {
                setTimeout(() => {
                    superScriptFixerUpper();
                }, 1100);
            });
        });
    }

    function superScriptFixerUpper() {
        convertBraceMarkersToSuperscripts();

        var footnoteSourceElements = document.querySelectorAll(footnoteSelector);
        var cachedFootnoteSourceElements = [];

        // Step 1: First pass - find all sources and give them unique IDs.
        // Labels come from (1)/[1]/1 prefixes, symbols, or ol > li position.
        footnoteSourceElements.forEach(function (source) {
            const footnoteLabel = getSourceLabel(source);
            if (!footnoteLabel) {
                return;
            }

            if (!source.id) {
                source.id = "source-" + Math.random().toString(36).substring(2, 7);
            }
            cachedFootnoteSourceElements.push({
                el: source,
                label: footnoteLabel,
            });
        });

        // Step 2: Process all reference elements
        var superscriptElements = document.querySelectorAll(superscriptSelector);
        
        superscriptElements.forEach(function (element) {
            linkFootnoteElement(element, cachedFootnoteSourceElements);
        });
    }

    function findSourceForReference(element, referenceLabel, cachedFootnoteSourceElements) {
        var module = element.closest('.module');
        var sameModuleSource = null;
        var followingSource = null;

        for (let i = 0; i < cachedFootnoteSourceElements.length; i++) {
            const source = cachedFootnoteSourceElements[i];
            if (source.label !== referenceLabel) {
                continue;
            }

            var position = element.compareDocumentPosition(source.el);
            var inSameModule = module && module.contains(source.el);

            if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
                if (inSameModule) {
                    return source.el;
                }
                if (!followingSource) {
                    followingSource = source.el;
                }
            } else if (inSameModule && !sameModuleSource) {
                sameModuleSource = source.el;
            }
        }

        return followingSource || sameModuleSource;
    }

    function revealFootnoteSource(target, thenScroll) {
        const collapsePanel = target.closest('.panel-collapse.collapse');
        if (!collapsePanel || collapsePanel.classList.contains('show')) {
            thenScroll();
            return;
        }

        const handleShown = function () {
            collapsePanel.removeEventListener('shown.bs.collapse', handleShown);
            thenScroll();
        };

        collapsePanel.addEventListener('shown.bs.collapse', handleShown);

        if (typeof bootstrap !== 'undefined' && bootstrap.Collapse) {
            bootstrap.Collapse.getOrCreateInstance(collapsePanel, { toggle: false }).show();
        } else {
            collapsePanel.classList.add('show');
            handleShown();
        }

        const accordionRoot = collapsePanel.closest('.footnotes, .collapse-section');
        const btn = accordionRoot ? accordionRoot.querySelector('.accordion-btn') : null;
        if (btn) {
            btn.classList.remove('collapsed');
            btn.setAttribute('aria-expanded', 'true');
        }
    }

    function linkFootnoteElement(element, cachedFootnoteSourceElements) {
        if (element.closest('a.footnote-link, a.span-asterisk')) {
            return;
        }
        if (element.closest('.footnotes .text, .row-footnotes-accordion .panel-collapse, .source, .financial-disclaimer')) {
            return;
        }

        element.innerHTML = superScriptReplace(element.innerHTML);
        var elementText = element.textContent;
        var footnoteLabel = getFootnoteLabel(elementText, element);
        let existingLink = element.querySelector('a.footnote-link, a.span-asterisk')
            || (element.tagName === 'A' && (element.classList.contains('footnote-link') || element.classList.contains('span-asterisk')) ? element : null);

        if (existingLink) {
            return;
        }

        if (!footnoteLabel) {
            if (element.tagName !== 'SUP') {
                element.querySelectorAll('sup').forEach(function (supEl) {
                    linkFootnoteElement(supEl, cachedFootnoteSourceElements);
                });
            }
            return;
        }

        const refId = "footnote-ref-" + Math.random().toString(36).substring(2, 7);
        if (!element.id) {
            element.id = "footnote-" + Math.random().toString(36).substring(2, 7);
        }

        var referenceLabel = normalizeFootnoteLabel(footnoteLabel);
        var sourceElement = findSourceForReference(element, referenceLabel, cachedFootnoteSourceElements);

        if (!sourceElement) {
            return;
        }

        const sourceId = sourceElement.id;
        var sup = document.createElement("sup");
        var link = document.createElement("a");
        link.href = "#" + sourceId;
        link.id = refId;
        link.textContent = footnoteLabel;
        link.classList.add('footnote-link');

        element.textContent = elementText.replace(footnoteLabel, '');

        if (element.tagName !== 'SUP') {
            sup.appendChild(link);
            element.appendChild(sup);
        } else {
            element.appendChild(link);
        }

        if (!sourceElement.querySelector('.footnote-backlink')) {
            var sourceText = sourceElement.textContent.trim();
            var startsWithLabel = sourceText.startsWith(footnoteLabel)
                || sourceText.startsWith(referenceLabel)
                || sourceText.startsWith('(' + referenceLabel + ')')
                || sourceText.startsWith('[' + referenceLabel + ']');

            if (startsWithLabel) {
                const backlink = document.createElement('a');
                backlink.href = "#" + refId;
                backlink.textContent = footnoteLabel;
                backlink.classList.add('footnote-backlink');

                const newText = sourceElement.textContent.replace(new RegExp('^\\s*(?:\\(|\\[)?' + referenceLabel.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?:\\)|\\])?\\s*'), '');
                sourceElement.textContent = '';
                sourceElement.appendChild(backlink);
                sourceElement.appendChild(document.createTextNode(' ' + newText));
            }
        }
    }

    function convertBraceMarkersToSuperscripts() {
        var skipClosest = '.financial-disclaimer, .source, .row-source, .footnotes';
        var skipTag = 'script, style, textarea, code, pre';

        document.querySelectorAll('.module *, .main-content *').forEach(function (el) {
            if (el.matches(skipTag)) {
                return;
            }
            if (el.closest(skipClosest)) {
                return;
            }
            if (typeof el.innerHTML !== 'string' || el.innerHTML.indexOf('{{') === -1) {
                return;
            }

            var hasChildWithMarker = false;
            for (var i = 0; i < el.children.length; i++) {
                if (el.children[i].innerHTML && el.children[i].innerHTML.indexOf('{{') !== -1) {
                    hasChildWithMarker = true;
                    break;
                }
            }
            if (hasChildWithMarker) {
                return;
            }

            el.innerHTML = superScriptReplace(el.innerHTML);
        });
    }

    function isOlListItem(element) {
        return element
            && element.tagName === 'LI'
            && element.parentElement
            && element.parentElement.tagName === 'OL';
    }

    function normalizeFootnoteLabel(label) {
        if (!label) {
            return null;
        }

        var trimmed = String(label).trim();
        var wrapped = trimmed.match(/^(?:\(|\[)\s*([a-zA-Z0-9]+)\s*(?:\)|\])$/);
        if (wrapped) {
            return wrapped[1];
        }

        return trimmed;
    }

    function extractBareLeadingNumber(text) {
        var match = String(text).trim().match(/^(\d+)(?:[.)]\s*|\s+)/);
        if (match) {
            return match[1];
        }

        return null;
    }

    function getOlItemIndexLabel(element) {
        if (!isOlListItem(element)) {
            return null;
        }

        var items = [];
        var children = element.parentElement.children;
        for (var i = 0; i < children.length; i++) {
            if (children[i].tagName === 'LI') {
                items.push(children[i]);
            }
        }

        var position = items.indexOf(element) + 1;
        if (position < 1) {
            return null;
        }

        return String(position);
    }

    function getSourceLabel(source) {
        var fromText = getFootnoteLabel(source.textContent, source);
        if (fromText) {
            return normalizeFootnoteLabel(fromText);
        }

        var leadingNumber = extractBareLeadingNumber(source.textContent);
        if (leadingNumber) {
            return leadingNumber;
        }

        return getOlItemIndexLabel(source);
    }

    function extractNumberOrLetter(text, isSup) {
        if (isSup) {
            var bare = String(text).trim().match(superscriptRegexBare);
            if (bare) {
                return bare[0];
            }
        }

        var number = text.match(superscriptRegexStart);
        if (!number) {
            number = text.match(superscriptRegexEnd);
        }
        return number ? number[0] : null;
    }

    // Get superscript symbol from text
    function extractSuperscriptSymbol(text) {
        const superscriptSymbol = text.match(superscriptSymbolRegex);
        if (superscriptSymbol) {
            return superscriptSymbol[0];
        }
        return null;
    }

    // Get number or symbol from footnote reference
    function getFootnoteLabel(elementText, element) {
        var isSup = element && element.tagName === 'SUP';
        let footnoteLabel = extractNumberOrLetter(elementText, isSup);

        if (!footnoteLabel) {
            footnoteLabel = extractSuperscriptSymbol(elementText);
        }
        return footnoteLabel || null;
    }

    // Simple regex to replace {{x}} with <sup>x</sup>
    function superScriptReplace(text) {
        return text.replace(/\{\{([^{}]+)\}\}/g, function (match, inner) {
            return inner.split(/\s*,\s*/).map(function (part) {
                return '<sup>' + part.trim() + '</sup>';
            }).join(',');
        });
    }

});